import React from 'react';
import './Footer.scss';
import { RiCopyrightLine } from 'react-icons/ri';


export default function Footer() {
    return (
        <div className="footer-container">
            <p>Copyright </p>
            <RiCopyrightLine />
            <p>{new Date().getFullYear()} - All Rights Reserved</p>
        </div>
    );
}

